import { Theme } from "@mui/material";

export const selectStyles = (theme: Theme) => ({
  MuiSelect: {
    styleOverrides: {
      root: {
        height: '36px',
        color: theme.palette.text.primary,
        fontSize: '14px',
        padding: '0 10px',
      },
    },
  },
});
